// import React from "react";
// import "./blogs_user.css";
// import pr2 from "../../img/des_sec/our_story_img.svg";
// import coreImg from "../../img/Blogs_header.png";
// import pr3 from "../../img/Feature 2.png";
// import pr4 from "../../img/Feature 3.png";
// // import pr4 from "../../img/wikiworks logo 230725-01 2.png";
// import "../our_story/ourStory.css";
// import CaseStudiesContainer from "../case_studies/case_studies";
// import Blogs from "../blogs/blogs";

// import { Swiper, SwiperSlide } from "swiper/react";
// import CertifiedPartner from "../certified_partner/certified_partner";
// import ServiceOfferings from "../service_offering/service_offerings";
// import "swiper/css";
// import "swiper/css/pagination";
// import "swiper/css/navigation";
// import BlogHero from "../blog_hero/blog_hero";

// function BlogUser({ openModal }) {
//   return (
//     <div className="whoWeAreMain-o-u">
//       <BlogHero />
//       <h1 className="whoWeAreHeader-o">Our Story</h1>
//       <div id="WhoWeAre" className="whoWeAreUp-o">
//         <div className="whoWeAreRight-o">
          

//           <div className="whoWeAreText-o">
//             <p
//               style={{
//                 wordWrap: "break-word", // Wrap long words to avoid overflow
//                 whiteSpace: "normal", // Allow text to wrap and break lines
//               }}
//             >
//               At WikiWorks, we are a B2B SaaS company dedicated to transforming
//               the HR tech landscape, with a particular focus on contract
//               workforce management. Our solutions empower organizations to
//               streamline the complexities of managing a contract workforce, from
//               onboarding and compliance to performance tracking.
//             </p>
//           </div>
//         </div>

//         <div className="whoWeAreLeft-o">
//           <img src={pr2} alt="pr2" />
//         </div>
//       </div>

//       <CaseStudiesContainer />
//       <Blogs />
//     </div>
//   );
// }

// export default BlogUser;


import React from "react";
import "./blogs_user.css";
import pr2 from "../../img/des_sec/our_story_img.svg";
import CaseStudiesContainer from "../case_studies/case_studies";
import Blogs from "../blogs/blogs";
import "../our_story/ourStory.css";
import BlogHero from "../blog_hero/blog_hero";
import { useSpring, animated } from "react-spring";
import { useInView } from "react-intersection-observer";

function BlogUser({ openModal }) {
  const [refText, inViewText] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [refImage, inViewImage] = useInView({ triggerOnce: true, threshold: 0.2 });

  const textAnimation = useSpring({
    opacity: inViewText ? 1 : 0,
    transform: inViewText ? "translateY(0)" : "translateY(40px)",
    config: { duration: 700 },
  });

  const imageAnimation = useSpring({
    opacity: inViewImage ? 1 : 0,
    transform: inViewImage ? "translateX(0)" : "translateX(-40px)",
    config: { duration: 700 },
  });

  return (
    <div className="whoWeAreMain-o-u">
      <BlogHero />
      <h1 className="whoWeAreHeader-o">Our Story</h1>
      <div id="WhoWeAre" className="whoWeAreUp-o">
        <animated.div className="whoWeAreRight-o" ref={refText} style={textAnimation}>
          <div className="whoWeAreText-o">
            <p
              style={{
                wordWrap: "break-word",
                whiteSpace: "normal",
              }}
            >
              At WikiWorks, we are a B2B SaaS company dedicated to transforming
              the HR tech landscape, with a particular focus on contract
              workforce management. Our solutions empower organizations to
              streamline the complexities of managing a contract workforce, from
              onboarding and compliance to performance tracking.
            </p>
          </div>
        </animated.div>

        <animated.div className="whoWeAreLeft-o" ref={refImage} style={imageAnimation}>
          <img src={pr2} alt="pr2" />
        </animated.div>
      </div>

      <CaseStudiesContainer />
      <Blogs />
    </div>
  );
}

export default BlogUser;
